import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5StaticDatumsEdit } from "./edit";
import { C5StaticDataNew } from "./new";
import { C5StaticDatumsTable } from "./table";
export default function C5StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5StaticDatumsEdit />} />
      <Route index element={<C5StaticDatumsTable />} />
      <Route path="/new" element={<C5StaticDataNew />} />
    </Routes>
  );
}
